import AmexGDADir, { ComponentAmexGDADirUnderTest } from './AmexGDADir';

export default AmexGDADir;
export { ComponentAmexGDADirUnderTest };
